import { parseISO } from 'date-fns';
import React from 'react';

import {
  LicenseDemoPeriodModel,
  LicenseModel,
} from '../../../../../typings/api/skymap/rest/v0/.common';

type ReturnType = {
  latestLicenseDemoPeriod?: LicenseDemoPeriodModel;
};

/**
 * Currently returns the latest license demo period if any.
 */
const useLicense = <T extends LicenseModel | undefined>(
  license?: T,
): T extends LicenseModel ? ReturnType : Partial<ReturnType> => {
  const latestLicenseDemoPeriod = React.useMemo(
    () =>
      license?.licenseDemoPeriods?.sort(
        (a, b) => parseISO(b.createdAt).getTime() - parseISO(a.createdAt).getTime(),
      )[0],
    [license?.licenseDemoPeriods],
  );

  return {
    latestLicenseDemoPeriod,
  } as T extends LicenseModel ? ReturnType : Partial<ReturnType>;
};

export { useLicense };
